import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import PropertyDetail from "./pages/PropertyDetail";
import About from "./pages/About";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import LeadsManager from "./pages/LeadsManager";
import PropertyForm from "./pages/PropertyForm";

// Layout con Header y Footer
const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
};

// Layout sin Header/Footer (para admin)
const AdminLayout = ({ children }) => {
  return <main>{children}</main>;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Rutas públicas con Header y Footer */}
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/propiedad/:id" element={<Layout><PropertyDetail /></Layout>} />
          <Route path="/acerca" element={<Layout><About /></Layout>} />
          
          {/* Rutas de administración sin Header/Footer */}
          <Route path="/admin" element={<AdminLayout><AdminLogin /></AdminLayout>} />
          <Route path="/admin/dashboard" element={<AdminLayout><AdminDashboard /></AdminLayout>} />
          <Route path="/admin/leads" element={<AdminLayout><LeadsManager /></AdminLayout>} />
          <Route path="/admin/property/new" element={<AdminLayout><PropertyForm /></AdminLayout>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
